import { render, staticRenderFns } from "./CouponRedemptions.vue?vue&type=template&id=788a0833&scoped=true"
import script from "./CouponRedemptions.vue?vue&type=script&lang=js"
export * from "./CouponRedemptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a0833",
  null
  
)

export default component.exports